import {
  VolumeDiscountPriceTierCreateRequestType,
  VolumeDiscountPriceTierCreateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useVolumeDiscountPriceTierCreate = (volumeDiscountId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: VolumeDiscountPriceTierCreateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `volume-discounts/${volumeDiscountId}/price-tiers`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as VolumeDiscountPriceTierCreateResponseType,
      ),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.PriceTierVolumeDiscounts],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.VolumeDiscounts],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.PriceTiers],
      });
    },
  });
};
